<template>
	<div id="app-layout" :style="`padding-top: ${navbarHeight}px`">
		<h1-safety-flash-banner />
		<!-- <survey-modal v-if="shouldShowSurveyModal && !POS_MODE" @sent="surveyModalSent()" /> -->
		<promo-sale-reminder-modal-container />
		<app-header
			@logout="resetHeap()"
		/>
		<div
			id="app-body"
			:class="{ 'app-body--loading' : showLoading }"
		>
			<loading v-show="showLoading" />
			<!-- Vue router -->
			<router-view :key="$route.path"/>
		</div>
		<app-footer v-if="!POS_MODE && showFooter" />
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import CONSTANTS from "./config/constants";
import uuidv4 from "uuid/v4";
import Footer from "./footer.vue";
import Header from "./header.vue";
// import SurveyModal from "./components/generals/survey-modal.vue";
import { heapAnalytics } from "@u/mixins";
import { isMobile } from "@u/helpers.js";
import metaTags from "./metaTags.json";
import { gtmTrack } from "@/util/gtm";
import PromoSaleReminderModalContainer from "@c/hero-section/promo-sale-reminder-modal-container";
import h1SafetyFlashBanner from "./components/store/flash-banners/h1-safety-banner";

export default {
	name: "App",
	components: {
		AppHeader: Header,
		AppFooter: Footer,
		PromoSaleReminderModalContainer,
		h1SafetyFlashBanner
		// SurveyModal
	},
	mixins: [
		heapAnalytics
	],
	metaInfo() {
		return this.meta;
	},
	data() {
		return {
			shouldShowSurveyModal: !location.pathname.startsWith("/pc-rental"),
			idleTime: 0,
			idleTimeout: null,
			intervalId: null,
			meta: {},
			navbarHeight: 90
		};
	},
	computed: {
		...mapState({
			showLoading: state => state.Application.showLoading,
			countryCode: state => state.User.location.country_code
		}),
		showFooter() {
			const configuratorRoutes = [
				"step1",
				"step2",
				"step3",
				"step5"
			];
			return !(configuratorRoutes.includes(this.$route.name) && isMobile());
		}
	},
	watch: {
		$route() {
			this.setMetaTags();
		}
	},
	updated() {
		this.setNavbarHeight();
	},
	created() {
		this.getUserLocation()
			.then(() => {
				gtmTrack.userSession(this.countryCode);
			});
		this.getShippingRates();
		this.initSurveyInterval();
		this.redirectOldUlrs();
		this.processHeap();

		if (typeof this.calculateSurveyIdleTime === "function") {
			this.calculateSurveyIdleTime();
		}

		EventBus.$on("user-logged-in", () => {
			this.processHeap();
		});

		if (this.POS_MODE) {
			document.querySelector("body").classList.add("pos-mode");
		}
	},
	mounted() {
		$(document).on("hidden.bs.modal", () => {
			if ($(".modal:visible").length) {
				$("body").addClass("modal-open");
			}
		});

		this.setNavbarHeight();

		window.paybright.load();
	},
	methods: {
		...mapActions({
			getUserLocation: "getUserLocation",
			getShippingRates: "Application/getShippingRates"
		}),
		setMetaTags() {
			const metaDescription = document.head.querySelector("meta[name=description]");
			const metaKeywords = document.head.querySelector("meta[name=keywords]");

			for (const tag in metaTags) {
				if (this.$route.name == "home") {
					this.meta = {
						title: "GAMING PCs MADE SIMPLE"
					};

					metaKeywords.content = "gaming pc, pc gaming, gaming build, build your own pc, budget gaming pc, best gaming pc, gaming computer, gaming desktop, best affordable gaming pc";
				}

				if (this.$route.path.includes(tag)) {
					this.meta = {
						title: metaTags[tag].title
					};

					metaDescription.content = metaTags[tag].metaTags.description;
					metaTags[tag].metaTags.keywords ? metaKeywords.content = metaTags[tag].metaTags.keywords : "";
				}
			}
		},
		calculateSurveyIdleTime() {
			const surveyCookie = Cookies.get(CONSTANTS.COOKIES.SURVEY_SUBMITTED);

			if (surveyCookie) {
				let expirationTime;
				if (surveyCookie == "survey-closed") {
					expirationTime = +Cookies.get(CONSTANTS.COOKIES.SURVEY_CLOSED_EXPIRATION_TIME);
				} else {
					expirationTime = +Cookies.get(CONSTANTS.COOKIES.SURVEY_SUBMITTED_EXPIRATION_TIME);
				}
				this.idleTimeout = (expirationTime - moment().valueOf()) / 0.001;
			} else {
				const FIVE_MINUTES_IN_SECS = 300;
				this.idleTimeout = FIVE_MINUTES_IN_SECS;
			}
		},
		processHeap() {
			if (Cookies.get("cookies_id") && Cookies.get("email")) {
				heap.identify(Cookies.get("email"), "email");
			} else {
				if (!localStorage.getItem("heap-uuid")) {
					localStorage.setItem("heap-uuid", uuidv4());
				}

				heap.identify(localStorage.getItem("heap-uuid"), "Anonymous ID");
			}
		},
		redirectOldUlrs() {
			if (/#!\/\?(saved|draft|shared)=/i.test(window.location.hash)) {
				const draftId = window.location.hash.replace(/#!\/\?(saved|draft|shared)=/i, "");

				if (draftId) {
					this.$router.push({ path: `/bld/step4?price=1000&draft=${draftId}` });
				}
			}
		},
		resetHeap() {
			localStorage.removeItem("heap-uuid");
			heap.resetIdentity();
			this.processHeap();
		},
		surveyModalSent() {
			this.calculateSurveyIdleTime();
			this.initSurveyInterval();
		},
		initSurveyInterval() {
			$(document).on("click mousemove keypress", _.debounce(this.resetIdleTime, 250));
			this.intervalId = setInterval(this.checkIdleTime, 1000);
		},
		resetIdleTime() {
			this.idleTime = 0;
			this.calculateSurveyIdleTime();
		},
		checkIdleTime() {
			this.idleTime += 1;

			if (this.idleTime >= this.idleTimeout) {
				clearInterval(this.intervalId);
				$(document).off("click mousemove keypress", this.resetIdleTime);
				this.idleTime = 0;
				this.$modal.show("survey");
				this.track("Client: Exit Survey Shown");
			}
		},
		setNavbarHeight() {
			const navbars = [...document.querySelectorAll("[data-navbar]")];
			const navbarsHeights = navbars.map(navbar => navbar.offsetHeight);
			this.navbarHeight = Math.max(...navbarsHeights);
		}
	}
};
</script>

<style lang="scss">

.zd-widget-move-step1 {
	#launcher {
		@media (max-width: 480px) {
			bottom: 150px !important;
		}

		@media (min-width: 480px) and (max-width: 767px) {
			bottom: 105px !important;
		}
	}
}

.zd-widget-move-step3 {
	#launcher {
		@media (max-width: 991px) {
			bottom: 100px !important;
		}
	}
}


.zd-widget-move-step5 {
	#launcher {
		@media (max-width: 767px) {
			bottom: 90px !important;
		}
	}
}

.zd-widget-move-step5-holiday.zd-widget-move-step5 {
	#launcher {
		@media (max-width: 767px) {
			bottom: 165px !important;
		}
	}
}

</style>

<style lang="scss" scoped>
.app-body--loading {
	min-height: 60vh;
}
</style>
